module.exports = __webpack_public_path__ + "img/yellow-mode.e48a4ee5.svg";